import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getCart,
  removeCartItem,
  addItemToCart,
  updateCartItem,
  resetCartSteps,
  clearCartSidebarSteps,
} from "../Redux/Customers/Cart/Action";

import { Spinner } from "react-bootstrap";
import { createOrder, getOrderById } from "../Redux/Customers/Order/Action";
import "./SocialMedia.css";
import { createPayment } from "../Redux/Customers/Payment/Action";
import axios from "axios";
import { Plus } from "lucide-react";
import { toast } from "react-toastify";
import RecommendedSection from "./SideBar/RecommendedSection";
import CheckoutAddressForm from "./SideBar/CheckoutAddressForm ";
import OrderSummaryBill from "./SideBar/OrderSummaryBill";
import CartItemsList from "./SideBar/CartItemsList";


export default function SidebarCart({ isOpen, onClose, showBanner }) {
  const { auth } = useSelector((store) => store);
  const resetSteps = useSelector((state) => state.cart.resetSteps);


  const [couponCode, setCouponCode] = useState("");
  const [currentStep, setCurrentStep] = useState(1); // 1: Cart, 2: Address, 3: Payment
  const [selectedAddressId, setSelectedAddressId] = useState(null); // Track selected address ID
  const [recommendedItems, setRecommendedItems] = useState([]);
  const { order } = useSelector((state) => state);
  console.log(order.order?.shippingAddress, "order");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [waybillData, setWaybillData] = useState(null);
  const [jwtToken, setJwtToken] = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
  const [deliveryAddress, setDeliveryAddress] = useState({
    firstName: "",
    lastName: "",
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    mobile: "",
  });
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const jwt = localStorage.getItem("jwt");
  const { cart } = useSelector((store) => store);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("order_id");
  const [updatingItems, setUpdatingItems] = useState([]); // Track updating item IDs
  const [priceLoading, setPriceLoading] = useState(false);

  // console.log("orderId ", order);
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await dispatch(getCart(jwt));
        const tokenRes = await axios.get(
          "https://apigateway.bluedart.com/in/transportation/token/v1/login",
          {
            headers: {
              Accept: "application/json",
              ClientID: "uTGmdHAufhKOiDQG9El8LAS66HG539yT",
              ClientSecret: "qKA8mU7UKlw7Ah8h",
            },
          }
        );
        setJwtToken(tokenRes.data.JWTToken);
        if (orderId) {
          await dispatch(getOrderById(orderId));
        }
      } catch (err) {
        console.error("Initial sidebar load failed", err);
      } finally {
        setInitialLoading(false);
      }
    };

    if (isOpen) {
      fetchInitialData();
    }
  }, [isOpen, jwt, orderId, dispatch]);

  const refreshTrigger = useSelector((state) => state.cart.sidebarRefreshTrigger);

  useEffect(() => {
    if (isOpen) {
      dispatch(getCart(jwt));
    }
  }, [refreshTrigger, isOpen]);

  console.log(waybillData?.GenerateWayBillResult?.AWBNo || 'AWB number not available');


  useEffect(() => {
    if (!orderId) return
    dispatch(getOrderById(orderId));
  }, [orderId]);

  const handleCreatePayment = async () => {
    setLoading(true);
    if (!order.order) return
    try {
      const data = { orderId: order.order?._id, jwt };
      const paymentUrl = await dispatch(createPayment(data));
      if (paymentUrl) {
        window.location.href = paymentUrl;
      } else {
        toast.error("Payment link not generated!");
      }
    } catch (error) {
      console.error("Payment failed:", error);
      toast.error("Payment failed! Please try again.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const fetchToken = async () => {
      try {
        const response = await axios.get(
          "https://apigateway.bluedart.com/in/transportation/token/v1/login",
          {
            headers: {
              Accept: "application/json",
              ClientID: "uTGmdHAufhKOiDQG9El8LAS66HG539yT",
              ClientSecret: "qKA8mU7UKlw7Ah8h",
            },
          }
        );
        setJwtToken(response.data.JWTToken);
      } catch (error) {
        console.error(
          "Failed to fetch token:",
          error.response?.data || error.message
        );
      }
    };
    fetchToken();
  }, []);

  const handleRemoveItemFromCart = async (item) => {
    if (!item?._id) {
      console.error("Invalid cart item - missing ID");
      return;
    }
    try {
      const data = {
        cartItemId: item._id,
        jwt,
      };
      await dispatch(removeCartItem(data));

      // ✅ Force refresh cart from backend
      await dispatch(getCart(jwt));

      toast.success("Item removed from cart", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: false,
      });
    } catch (error) {
      console.error("Failed to remove item:", error);
      toast.error("Failed to remove item", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeButton: ({ closeToast }) => (
          <button
            onClick={closeToast}
            className="custom-toast-close"
            aria-label="close"
          >
            ×
          </button>
        ),
      });
    }
  };


  const handleSubmit = async (event, addressId = null) => {
    console.log("addressId", addressId);
    event.preventDefault();
    setLoading(true);
    try {
      let payload;
      if (addressId) {
        // 🟢 If address is selected from saved list, only send _id
        payload = {
          addressId,
          jwt,
          navigate,
        };
      } else {
        // 🟡 If adding new address, send full address
        payload = {
          address: deliveryAddress,
          jwt,
          navigate,
        };
      }
      console.log("payload", payload);
      await dispatch(createOrder(payload));
      setCurrentStep(3);
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  const generateRandomSixDigit = () => {
    return Math.floor(100000 + Math.random() * 900000);
  };
  const randomSixDigit = generateRandomSixDigit();
  // console.log("6-digit number:", randomSixDigit);

  const handleCreateOrder = (item) => {
    dispatch(createOrder({ address: item, addressId: selectedAddressId, jwt, navigate }));
    setCurrentStep(3);
  };

  useEffect(() => {
    dispatch(getCart(jwt));
  }, [jwt, dispatch]);

  useEffect(() => {
    if (resetSteps) {
      setCurrentStep(1); // reset to Cart step
      dispatch(resetCartSteps()); // turn it off again
    }
  }, [resetSteps, dispatch]);

  useEffect(() => {
    const fetchRecommendedProducts = async () => {
      try {
        const res = await fetch(
          "https://api.econirmit.com/api/products?color=&size=&minPrice=0&maxPrice=10000&minDiscount=0&category=all&stock=null&sort=price_low&pageNumber=1&pageSize=20"
        );
        const data = await res.json();
        const cartProductIds = cart.cartItems.map((item) => item.product._id);
        const recommended = data.content
          .filter((product) => !cartProductIds.includes(product._id))
          .slice(0, 3);
        const formattedRecommended = recommended.map((product) => ({
          id: product._id,
          name: product.title,
          img:
            product.colorVariants?.[0]?.images?.find(
              (img) => img.label === "front"
            )?.url || "https://via.placeholder.com/150",
          alt: `Image of ${product.title}`,
          price: product.discountedPrice,
        }));
        setRecommendedItems(formattedRecommended);
      } catch (error) {
        console.error("Error fetching recommended products:", error);
        setRecommendedItems([]);
      }
    };

    if (cart.cartItems.length > 0) {
      fetchRecommendedProducts();
    }
  }, [cart.cartItems]);

  if (!isOpen) return null;

  const handleNextStep = () => {
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setDeliveryAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNavigate = () => {
    navigate(`/product/${recommendedItems?.id}`);
  };

  const renderStepIndicator = () => {
    return (
      <div className="step-indicator">
        <div className={`step ${currentStep >= 1 ? "active" : ""}`}>
          <span>1</span>
          <p>Cart</p>
        </div>
        <div className={`step ${currentStep >= 2 ? "active" : ""}`}>
          <span>2</span>
          <p>Delivery</p>
        </div>
        <div className={`step ${currentStep >= 3 ? "active" : ""}`}>
          <span>3</span>
          <p>Payment</p>
        </div>
      </div>
    );
  };

  const getCommodityDetails = () => {
    const validItems = cart.cartItems.filter((item) => item?.product?.title);
    return {
      CommodityDetail1: validItems[0]?.product?.title || "No items",
      CommodityDetail2: validItems[1]?.product?.title || "",
      CommodityDetail3:
        validItems.length > 2
          ? validItems[2]?.product?.title || `+${validItems.length - 2} more items`
          : validItems.length > 0
            ? `+${validItems.length - 2} more items`
            : "",
    };
  };

  const requestData = {
    Request: {
      Consignee: {
        AvailableDays: "",
        AvailableTiming: "",
        ConsigneeAddress1: deliveryAddress.streetAddress,
        ConsigneeAddress2: deliveryAddress.city,
        ConsigneeAddress3: deliveryAddress.city,
        ConsigneeAddressType: "",
        ConsigneeAddressinfo: "",
        ConsigneeAttention: "",
        ConsigneeBusinessPartyTypeCode: "",
        ConsigneeCityName: "",
        ConsigneeCountryCode: "",
        ConsigneeEmailID: "",
        ConsigneeFiscalID: "",
        ConsigneeFiscalIDType: "",
        ConsigneeFullAddress: "",
        ConsigneeGSTNumber: "",
        ConsigneeID: "",
        ConsigneeIDType: "",
        ConsigneeLatitude: "",
        ConsigneeLongitude: "",
        ConsigneeMaskedContactNumber: "",
        ConsigneeMobile: deliveryAddress.mobile,
        ConsigneeName: deliveryAddress.firstName,
        ConsigneePincode: deliveryAddress.zipCode,
        ConsigneeStateCode: "",
        ConsigneeTelephone: "",
        ConsingeeFederalTaxId: "",
        ConsingeeRegistrationNumber: "",
        ConsingeeRegistrationNumberIssuerCountryCode: "",
        ConsingeeRegistrationNumberTypeCode: "",
        ConsingeeStateTaxId: "",
      },
      Returnadds: {
        ManifestNumber: "",
        ReturnAddress1: "",
        ReturnAddress2: "",
        ReturnAddress3: "",
        ReturnAddressinfo: "",
        ReturnContact: "",
        ReturnEmailID: "",
        ReturnLatitude: "",
        ReturnLongitude: "",
        ReturnMaskedContactNumber: "",
        ReturnMobile: "",
        ReturnPincode: "",
        ReturnTelephone: "",
      },
      Services: {
        AWBNo: "",
        ActualWeight: "1.0",
        AdditionalDeclaration: "",
        AuthorizedDealerCode: "",
        BankAccountNumber: "",
        BillToAddressLine1: "",
        BillToCity: "",
        BillToCompanyName: "",
        BillToContactName: "",
        BillToCountryCode: "",
        BillToCountryName: "",
        BillToFederalTaxID: "",
        BillToPhoneNumber: "",
        BillToPostcode: "",
        BillToState: "",
        BillToSuburb: "",
        BillingReference1: "",
        BillingReference2: "",
        CessCharge: 0.0,
        CollectableAmount: 0.0,
        Commodity: getCommodityDetails(),
        CreditReferenceNo: randomSixDigit,
        CreditReferenceNo2: "",
        CreditReferenceNo3: "",
        CurrencyCode: "",
        DeclaredValue: 2300.0,
        DeliveryTimeSlot: "",
        Dimensions: [
          {
            Breadth: 10.0,
            Count: 1,
            Height: 10.0,
            Length: 20.0,
          },
        ],
        ECCN: "",
        EsellerPlatformName: "",
        ExchangeWaybillNo: "",
        ExportImportCode: "",
        ExportReason: "",
        ExporterAddressLine1: "",
        ExporterAddressLine2: "",
        ExporterAddressLine3: "",
        ExporterBusinessPartyTypeCode: "",
        ExporterCity: "",
        ExporterCompanyName: "",
        ExporterCountryCode: "",
        ExporterCountryName: "",
        ExporterDivision: "",
        ExporterDivisionCode: "",
        ExporterEmail: "",
        ExporterFaxNumber: "",
        ExporterMobilePhoneNumber: "",
        ExporterPersonName: "",
        ExporterPhoneNumber: "",
        ExporterPostalCode: "",
        ExporterRegistrationNumber: "",
        ExporterRegistrationNumberIssuerCountryCode: "",
        ExporterRegistrationNumberTypeCode: "",
        ExporterSuiteDepartmentName: "",
        FavouringName: "",
        ForwardAWBNo: "",
        ForwardLogisticCompName: "",
        FreightCharge: 0.0,
        GovNongovType: "",
        IncotermCode: "",
        InsuranceAmount: 0.0,
        InsurancePaidBy: "",
        InsurenceCharge: 0.0,
        InvoiceNo: "",
        IsCargoShipment: false,
        IsChequeDD: "",
        IsCommercialShipment: false,
        IsDedicatedDeliveryNetwork: false,
        IsDutyTaxPaidByShipper: false,
        IsEcomUser: false,
        IsForcePickup: false,
        IsIntlEcomCSBUser: false,
        IsPartialPickup: false,
        IsReversePickup: false,
        ItemCount: 1,
        MarketplaceName: "",
        MarketplaceURL: "",
        NFEIFlag: false,
        NotificationMessage: "",
        Officecutofftime: "",
        OrderURL: "",
        PDFOutputNotRequired: false,
        PackType: "",
        ParcelShopCode: "",
        PayableAt: "",
        PayerGSTVAT: 0.0,
        PickupDate: "/Date(1736504552000)/",
        PickupMode: "",
        PickupTime: "1600",
        PickupType: "O",
        PieceCount: "1",
        PreferredPickupTimeSlot: "",
        ProductCode: "A",
        ProductFeature: "",
        ProductType: 2,
        RegisterPickup: false,
        ReverseCharge: 0.0,
        SignatureName: "",
        SignatureTitle: "",
        SpecialInstruction: "",
        SubProductCode: "P",
        SupplyOfIGST: "",
        SupplyOfwoIGST: "",
        TermsOfTrade: "",
        TotalCashPaytoCustomer: 0.0,
        Total_IGST_Paid: 0.0,
        itemImg: [
          {
            AWBNo: "",
            ImageURL:
              "https://m.media-amazon.com/images/I/71MW1E0je-L._SX522_.jpg",
            ItemID: "Test Item ID1",
          },
          {
            AWBNo: "",
            ImageURL:
              "https://m.media-amazon.com/images/I/61LNnZPoKPS._SL1500_.jpg",
            ItemID: "Test Item ID1",
          },
        ],
        itemdtl: [
          {
            CGSTAmount: 0.0,
            CommodityCode: "",
            Discount: 0.0,
            HSCode: "",
            IGSTAmount: 0.0,
            IGSTRate: 0.0,
            Instruction: "",
            InvoiceNumber: "",
            IsMEISS: "",
            ItemID: "Test Item ID1",
            ItemName: "Test Item1",
            ItemValue: 0.0,
            Itemquantity: 0,
            LicenseNumber: "",
            ManufactureCountryCode: "",
            ManufactureCountryName: "",
            PerUnitRate: 0.0,
            PieceID: "",
            PieceIGSTPercentage: 0.0,
            PlaceofSupply: "",
            ProductDesc1: "",
            ProductDesc2: "",
            ReturnReason: "",
            SGSTAmount: 0.0,
            SKUNumber: "",
            SellerGSTNNumber: "",
            SellerName: "",
            SubProduct1: "Test Sub 1",
            SubProduct2: "Test Sub 2",
            SubProduct3: "Test Sub 3",
            SubProduct4: "Test Sub 4",
            TaxableAmount: 0.0,
            TotalValue: 0.0,
            Unit: "",
            Weight: 0.0,
            cessAmount: "0.0",
            countryOfOrigin: "",
            docType: "",
            subSupplyType: 0,
            supplyType: "",
          },
        ],
        noOfDCGiven: 0,
      },
      Shipper: {
        CustomerAddress1: "PUSHPANJALI ECONIRMIT",
        CustomerAddress2: "12/16, Pragati Nagar, Nanakheda,",
        CustomerAddress3: "UJJAIN",
        CustomerAddressinfo: "",
        CustomerBusinessPartyTypeCode: "",
        CustomerCode: "313460",
        CustomerEmailID: "contact@econirmit.com",
        CustomerFiscalID: "",
        CustomerFiscalIDType: "",
        CustomerGSTNumber: "",
        CustomerLatitude: "",
        CustomerLongitude: "",
        CustomerMaskedContactNumber: "",
        CustomerMobile: " 8827373432",
        CustomerName: "PUSHPANJALI ECONIRMIT",
        CustomerPincode: "456001",
        CustomerRegistrationNumber: "",
        CustomerRegistrationNumberIssuerCountryCode: "",
        CustomerRegistrationNumberTypeCode: "",
        CustomerTelephone: "",
        IsToPayCustomer: false,
        OriginArea: "UJJ",
        Sender: "",
        VendorCode: "",
      },
    },
    Profile: {
      Api_type: "S",
      Area: "UJJ",
      Customercode: "313460",
      IsAdmin: "",
      LicenceKey: "hugurthljkfzqmkm3tmjuokqiomjeosk",
      LoginID: "UJJ23580",
      Version: "1.8",
    },
  };

  const generateWaybill = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const response = await axios.post(
        "https://apigateway.bluedart.com/in/transportation/waybill/v1/GenerateWayBill",
        requestData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            JWTToken: jwtToken,
          },
        }
      );
      setWaybillData(response.data);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to generate waybill");
    } finally {
      setLoading(false);
    }
  };

  const shippingCharge = cart.cart?.totalDiscountedPrice < 750 ? 100 : 0;
  console.log(shippingCharge, "shippingCharge", cart.cart?.totalDiscountedPrice, "cart.cart?.totalDiscountedPrice")
  const finalAmount = (cart.cart?.totalDiscountedPrice || 0) + shippingCharge;

  const handleUpdateCartItem = async (item, num) => {
    const itemId = item._id;
    setUpdatingItems((prev) => [...prev, itemId]);
    setPriceLoading(true);
    const data = {
      data: { quantity: item.quantity + num },
      cartItemId: item?._id,
      jwt,
    };
    try {
      await dispatch(updateCartItem(data));
      await dispatch(getCart(jwt));
    } catch (error) {
      console.error("Failed to update cart item", error);
    } finally {
      setUpdatingItems((prev) => prev.filter((id) => id !== itemId));
      setPriceLoading(false);
    }
  };

  const productImage = (item) =>
    item?.product?.colorVariants?.[0]?.images?.find(
      (img) => img?.label === "front"
    )?.url ||
    item?.product?.colorVariants?.[0]?.images?.[0]?.url ||
    "https://via.placeholder.com/150";

  return (
    <>
      <aside
        className="sidebar-cart"
        aria-label="Shopping cart sidebar"
        style={{ top: showBanner ? "100px" : "60px", maxHeight: showBanner ? "calc(100vh - 100px)" : "calc(100vh - 60px)" }}
      >
        <header className="cart-header flex justify-between items-center">
          {cart.cart?.totalItem > 0 && (
            <div className="text-right w-full">
              <span role="img" aria-label="Shopping cart icon" aria-hidden="true">
                🛒
              </span>{" "}
              Your cart · {cart.cart.totalItem} items
            </div>
          )}
          <button
            className="ml-2"
            aria-label="Close cart sidebar"
            onClick={() => onClose()}
          >
            ×
          </button>
        </header>
        {initialLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "60vh",
            }}
          >
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            {currentStep === 1 ? (
              <>
                <CartItemsList
                  cartItems={cart.cartItems}
                  productImage={productImage}
                  handleRemoveItemFromCart={handleRemoveItemFromCart}
                  onIncreaseQuantity={(item) => handleUpdateCartItem(item, 1)}
                  onDecreaseQuantity={(item) => handleUpdateCartItem(item, -1)}
                  updatingItems={updatingItems}
                />
                <section className="coupon-section">
                  <input
                    type="text"
                    className="coupon-input"
                    placeholder="Enter coupon code"
                    value={couponCode}
                    aria-label="Enter coupon code"
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                </section>
                <footer className="cart-footer">
                  <div
                    className="total-container"
                    aria-live="polite"
                    aria-atomic="true"
                  >
                    {priceLoading ? (
                      <div className="flex items-center gap-2">
                        <span>Updating...</span>
                      </div>
                    ) : (
                      <>
                        <div className="total-amount">
                          ₹{cart.cart?.totalDiscountedPrice || 0}
                        </div>
                        <div className="estimated-label">Estimated total</div>
                      </>
                    )}
                  </div>
                  <button
                    className="checkout-btn"
                    aria-label="Proceed to checkout"
                    onClick={() => setCurrentStep(2)}
                    disabled={cart.cartItems.length === 0 || priceLoading}
                  >
                    {priceLoading ? (
                      <>
                        <Spinner
                          animation="border"
                          role="status"
                          size="sm"
                          style={{ marginRight: "5px" }}
                        />
                        Updating...
                      </>
                    ) : (
                      "Checkout"
                    )}
                  </button>
                </footer>
              </>
            ) : currentStep === 2 ? (
              <CheckoutAddressForm
                deliveryAddress={deliveryAddress}
                handleAddressChange={handleAddressChange}
                handleSubmit={handleSubmit}
                handlePrevStep={handlePrevStep}
                loading={loading}
                setSelectedAddressId={setSelectedAddressId} // Pass setter for address ID
              />
            ) : (
              <OrderSummaryBill
                deliveryAddress={deliveryAddress}
                cart={cart}
                handlePrevStep={handlePrevStep}
                handleCreatePayment={handleCreatePayment}
                generateWaybill={generateWaybill}
                loading={loading}
                setLoading={setLoading}
                toast={toast}
                order={order}
                orderId={orderId}
                shippingCharge={shippingCharge}
                finalAmount={finalAmount}
              />
            )}
          </>
        )}
      </aside>
    </>
  );
}